import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import { API } from '../App';

const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        const response = await axios.get(`${API}/faqs`);
        setFaqs(response.data);
      } catch (error) {
        console.error('Error fetching FAQs:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchFAQs();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#3B82F6]"></div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://www.extreme-clean.com.au/faq" />
        <title>FAQ | Extreme Clean Australia</title>
      </Helmet>
      <div className="min-h-screen bg-white pt-24 lg:pt-44" data-testid="faq-page">
      {/* Header */}
      <section className="bg-[#273268] py-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="font-heading font-bold text-4xl md:text-5xl leading-snug text-white" data-testid="faq-title">
            Frequently Asked Questions
          </h1>
          <p className="text-gray-400 mt-4 text-lg">
            Find answers to common questions about our cleaning services
          </p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          {faqs.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-gray-500">No FAQs available at the moment.</p>
            </div>
          ) : (
            <div className="space-y-12" data-testid="faq-list">
              {faqs.map((faq, index) => (
                <div key={faq.id || index} className="border-b border-gray-200 pb-8 last:border-b-0" data-testid={`faq-item-${index}`}>
                  <h2 className="font-heading font-bold text-xl md:text-2xl text-[#0A0A0A] mb-4" data-testid={`faq-question-${index}`}>
                    {faq.question}
                  </h2>
                  <p className="text-gray-700 leading-relaxed" data-testid={`faq-answer-${index}`}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-[#3B82F6] py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-white mb-4">
            Still Have Questions?
          </h2>
          <p className="text-white/80 mb-8">
            Our team is here to help. Get in touch for a free quote or to discuss your cleaning needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:0861875523"
              className="inline-flex items-center justify-center bg-white text-[#3B82F6] font-bold px-8 py-3 hover:bg-gray-100 transition-colors"
            >
              Call 08 6187 5523
            </a>
            <a
              href="/contact"
              className="inline-flex items-center justify-center border-2 border-white text-white font-bold px-8 py-3 hover:bg-white hover:text-[#3B82F6] transition-colors"
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>
    </div>
    </>
  );
};

export default FAQ;
